// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle-" + {"513":"8483eb645837c44ace8e","640":"4ab65b0be90aad82b4c2","890":"77c2bd81fc8ca571bae6"}[chunkId] + ".min.js";
};